import { UserListTablePanel } from "#src/batteries-included-components/Panels/TablePanels/UserListTablePanel";
import { useStorageKey } from "#src/hooks/useStorageKey";
import React from "react";

export const UserListTab = () => {
  const [filterConfigStorageKey, tableConfigStorageKey, tableStateStorageKey] =
    useStorageKey(
      ["filter-configuration", "table-configuration", "table-state"],
      "users"
    );

  return (
    <>
      <UserListTablePanel
        filterConfigStorageKey={filterConfigStorageKey}
        tableConfigStorageKey={tableConfigStorageKey}
        tableStateStorageKey={tableStateStorageKey}
      />
    </>
  );
};
